var _defs, _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThinkTanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#333;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.00046,25.66583c-9.65588,0-17.51221,7.85547-17.51221,17.51123,0,6.05176,3.08704,11.39453,7.76776,14.5415h19.48859c4.68042-3.14697,7.76715-8.48975,7.76715-14.5415,0-9.65576-7.85541-17.51123-17.51129-17.51123Zm7.30627,24.81769c-1.36053,1.36066-2.87616,2.42932-4.44379,3.20557h-11.16583c-.43292-.28918-.84863-.60712-1.22485-.98334-4.02893-4.02893-3.03223-11.58099,2.22174-16.8349,5.25323-5.2533,12.80518-6.25018,16.83417-2.22113,4.02844,4.02844,3.0321,11.5802-2.22144,16.8338Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 39.68747,
    y: 61.32379,
    width: 20.38391,
    height: 4.0293
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49.87943,74.33417c2.93896,0,5.32141-2.38245,5.32141-5.32141h-10.64282c0,2.93896,2.38251,5.32141,5.32141,5.32141Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThinkTanks);
export default __webpack_public_path__ + "static/media/icon_think_tanks.47da2753b721d4d1476bf9ce937c4c54.svg";
export { ForwardRef as ReactComponent };